interface HudState {
  levelName: string;
  levelIndex: number;
  totalLevels: number;
  objectiveLabel: string;
  progressLabel: string;
  targetLabel: string;
  score: number;
  elapsedSeconds: number;
  parSeconds: number;
  combo: number;
  prompt: string;
}

export class Hud {
  private readonly panel: HTMLDivElement;
  private readonly top: HTMLDivElement;
  private readonly meta: HTMLDivElement;
  private readonly prompt: HTMLDivElement;
  private readonly messageBubble: HTMLDivElement;

  constructor(root: HTMLElement) {
    this.panel = document.createElement('div');
    this.panel.className = 'hud';

    this.top = document.createElement('div');
    this.top.className = 'hud__top';
    this.panel.appendChild(this.top);

    this.meta = document.createElement('div');
    this.meta.className = 'hud__meta';
    this.panel.appendChild(this.meta);

    this.prompt = document.createElement('div');
    this.prompt.className = 'hud__prompt';

    this.messageBubble = document.createElement('div');
    this.messageBubble.className = 'message-bubble';
    this.messageBubble.style.display = 'none';

    root.append(this.panel, this.prompt, this.messageBubble);
  }

  public render(state: HudState): void {
    this.top.textContent = `\u0645\u0633\u062a\u0648\u0649 ${state.levelIndex}/${state.totalLevels}: ${state.levelName}`;
    this.meta.innerHTML = [
      `\u0646\u0642\u0627\u0637: ${state.score} | \u0648\u0642\u062a: ${state.elapsedSeconds}\u062b | \u0627\u0644\u0645\u0637\u0644\u0648\u0628: ${state.parSeconds}\u062b | \u0643\u0648\u0645\u0628\u0648 x${state.combo}`,
      `\u0647\u062f\u0641: ${state.objectiveLabel}`,
      `\u062a\u0642\u062f\u0645: ${state.progressLabel}`,
      `\u0627\u0644\u0648\u062c\u0647\u0629: ${state.targetLabel}`,
    ].join('<br />');

    this.prompt.textContent = state.prompt;
  }

  public showMessage(text: string): void {
    if (!text) {
      this.messageBubble.style.display = 'none';
      return;
    }
    this.messageBubble.textContent = text;
    this.messageBubble.style.display = 'block';
  }

  public hideMessage(): void {
    this.messageBubble.style.display = 'none';
    this.messageBubble.textContent = '';
  }

  public dispose(): void {
    this.panel.remove();
    this.prompt.remove();
    this.messageBubble.remove();
  }
}
